<template>
  <span class="asystent-360-mesh-orb" aria-hidden="true"></span>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Asystent360MeshOrb extends Vue {}
</script>

<style scoped>
.asystent-360-mesh-orb {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-block;
  background-color: #c4b5fd;
  background-image:
    radial-gradient(at 18% 22%, rgba(255, 150, 130, 0.95) 0%, transparent 55%),
    radial-gradient(at 82% 78%, rgba(60, 130, 255, 0.95) 0%, transparent 55%),
    radial-gradient(at 48% 52%, rgba(180, 140, 255, 0.85) 0%, transparent 60%);
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.35) inset,
    0 1px 4px rgba(99, 102, 241, 0.35),
    0 0 12px rgba(129, 140, 248, 0.25);
}
</style>
